/* La Bascule — aperçu 3D et guide de mesure animé (three.js r149) */
(function () {
  'use strict';
  var B = window.Bascule = window.Bascule || {};
  var threeP = null, modelP = {};

  B.loadThree = function () {
    if (window.THREE) return Promise.resolve(window.THREE);
    if (threeP) return threeP;
    threeP = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = B.assets.three; s.async = true;
      s.onload = function () { window.THREE ? res(window.THREE) : rej(new Error('three')); };
      s.onerror = function () { threeP = null; rej(new Error('three')); };
      document.head.appendChild(s);
    });
    return threeP;
  };
  B.loadModels = function (which) {
    var url = which === 'prise' ? B.assets.modelsPrise : B.assets.models;
    if (!modelP[url]) {
      modelP[url] = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('models'); return r.json(); }).then(function (j) { return j.models; });
      modelP[url].catch(function () { delete modelP[url]; });
    }
    return modelP[url];
  };
  B.webglOk = function () {
    try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); } catch (e) { return false; }
  };
  B.reducedMotion = function () {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  };

  function b64(s) { var bin = atob(s), u = new Uint8Array(bin.length); for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i); return u.buffer; }
  function decode(T, m) {
    var p16 = new Int16Array(b64(m.p)), pos = new Float32Array(p16.length);
    for (var i = 0; i < p16.length; i++) pos[i] = p16[i] * 0.01;
    var g = new T.BufferGeometry();
    g.setAttribute('position', new T.BufferAttribute(pos, 3));
    g.setAttribute('normal', new T.BufferAttribute(new Int8Array(b64(m.n)), 3, true));
    g.setIndex(new T.BufferAttribute(m.i32 ? new Uint32Array(b64(m.i)) : new Uint16Array(b64(m.i)), 1));
    g.computeBoundingSphere();
    return g;
  }
  function shape(T, w, h, r, cx) {
    var s = new T.Shape(), x = (cx || 0) - w / 2, y = -h / 2;
    s.moveTo(x + r, y); s.lineTo(x + w - r, y); s.quadraticCurveTo(x + w, y, x + w, y + r);
    s.lineTo(x + w, y + h - r); s.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    s.lineTo(x + r, y + h); s.quadraticCurveTo(x, y + h, x, y + h - r);
    s.lineTo(x, y + r); s.quadraticCurveTo(x, y, x + r, y);
    return s;
  }
  function roundRect(T, w, h, r, depth, bevel, back) {
    var g = new T.ExtrudeGeometry(shape(T, w, h, r), { depth: depth - 2 * bevel, bevelEnabled: true, bevelThickness: bevel, bevelSize: bevel, bevelSegments: 3, curveSegments: 6 });
    if (back) g.translate(0, 0, -depth + bevel); else g.translate(0, 0, bevel);
    return g;
  }

  /* ---------- Aperçu du cache ---------- */
  function Viewer(canvas, opts) {
    this.cv = canvas; this.onNight = opts && opts.onNight; this.models = {}; this.want = null; this.v = null;
  }
  Viewer.prototype.addModels = function (M) {
    var self = this; Object.keys(M).forEach(function (k) { self.models[k] = M[k]; });
    if (this.v) this._addCovers(M);
  };
  Viewer.prototype.init = function () {
    var T = window.THREE, cv = this.cv, M = this.models, self = this;
    try { T.ColorManagement.legacyMode = false; } catch (e) {}
    var r = new T.WebGLRenderer({ canvas: cv, antialias: true, alpha: true });
    r.outputEncoding = T.sRGBEncoding;
    r.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    var scene = new T.Scene(), cam = new T.PerspectiveCamera(26, 1, 10, 2000);
    var hemi = new T.HemisphereLight(0xfffaf0, 0xcfc6b4, 0.48); scene.add(hemi);
    var key = new T.DirectionalLight(0xffffff, 0.82); key.position.set(-110, 150, 130); scene.add(key);
    var fill = new T.DirectionalLight(0xfff4e2, 0.22); fill.position.set(140, -40, 120); scene.add(fill);
    var mat = function () { return new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.82, metalness: 0 }); };
    var piece = new T.Group(); piece.rotation.y = Math.PI; scene.add(piece);
    var coverMat = mat(), leverMat = mat();
    var leverGeo = decode(T, M.levier), embGeo = {};
    Object.keys(M).forEach(function (k) { if (k.indexOf('emb_') === 0) embGeo[k.slice(4)] = decode(T, M[k]); });
    var rigs = [-12, 0, 12].map(function (x) {
      var pivot = new T.Group(); pivot.position.set(x, 0, 6.25); piece.add(pivot);
      var lever = new T.Mesh(leverGeo, leverMat); lever.rotation.x = Math.PI; lever.position.z = 1.25; pivot.add(lever);
      var embs = {};
      Object.keys(embGeo).forEach(function (k) { var em = new T.Mesh(embGeo[k], leverMat); em.position.z = -21.75; em.visible = false; pivot.add(em); embs[k] = em; });
      return { x: x, pivot: pivot, lever: lever, embs: embs, tilt: -0.16, tiltNow: -0.16, rock: null };
    });
    var before = new T.Group(); scene.add(before);
    var whiteA = new T.MeshStandardMaterial({ color: 0xf7f6f1, roughness: 0.38 });
    var whiteB = new T.MeshStandardMaterial({ color: 0xfcfcf9, roughness: 0.32 });
    var plate = new T.Mesh(undefined, whiteA); before.add(plate);
    rigs.forEach(function (rg) {
      var rp = new T.Group(); rp.position.set(-rg.x, 0, -11); before.add(rp);
      var rk = new T.Mesh(undefined, whiteB); rk.position.z = 3; rp.add(rk);
      rg.rock = { pivot: rp, mesh: rk };
    });
    var socket = new T.Group(); before.add(socket);
    var disc = new T.Mesh(new T.CylinderGeometry(22, 22, 2, 72), new T.MeshStandardMaterial({ color: 0xecebe5, roughness: 0.4 }));
    disc.rotation.x = Math.PI / 2; disc.position.z = -10; socket.add(disc);
    var holeMat = new T.MeshStandardMaterial({ color: 0x2b2a2e, roughness: 0.9 });
    [-9.5, 9.5].forEach(function (x) { var h = new T.Mesh(new T.CylinderGeometry(2.4, 2.4, 0.4, 28), holeMat); h.rotation.x = Math.PI / 2; h.position.set(x, 0, -8.85); socket.add(h); });
    var pin = new T.Mesh(new T.CylinderGeometry(2.3, 2.3, 6, 28), new T.MeshStandardMaterial({ color: 0xb9b7ae, roughness: 0.35, metalness: 0.6 }));
    pin.rotation.x = Math.PI / 2; pin.position.set(0, 10, -6); socket.add(pin);
    this.v = { T: T, r: r, scene: scene, cam: cam, piece: piece, covers: {}, rigs: rigs, coverMat: coverMat, leverMat: leverMat, before: before, plate: plate, socket: socket,
      hemi: hemi, key: key, fill: fill, nNow: 0, fmt: 'simple',
      cDay: { sky: new T.Color(0xfffaf0), gnd: new T.Color(0xcfc6b4), key: new T.Color(0xffffff) },
      cNight: { sky: new T.Color(0x8e9ad6), gnd: new T.Color(0x1a1e50), key: new T.Color(0xa9b6ff) },
      yaw: -0.42, pitch: 0.26, raf: 0, dims: '', drag: null, ray: new T.Raycaster() };
    this._addCovers(M);
    if (window.ResizeObserver) { this.ro = new ResizeObserver(function () { self.resize(); }); this.ro.observe(cv); }
    else window.addEventListener('resize', function () { self.resize(); });
    this._bind();
    this.resize();
    this.sync();
  };
  Viewer.prototype._addCovers = function (M) {
    var v = this.v, T = v.T;
    Object.keys(M).forEach(function (k) {
      if (k === 'levier' || k.indexOf('emb_') === 0 || v.covers[k]) return;
      var mesh = new T.Mesh(decode(T, M[k]), v.coverMat); mesh.visible = false;
      v.piece.add(mesh); v.covers[k] = mesh;
    });
    this.v.dims = '';
    this.sync();
  };
  Viewer.prototype.hasCover = function (k) { return !!(this.v && this.v.covers[k]); };
  Viewer.prototype._bind = function () {
    var self = this, cv = this.cv;
    cv.addEventListener('pointerdown', function (e) { self.down(e); });
    cv.addEventListener('pointermove', function (e) { self.move(e); });
    cv.addEventListener('pointerup', function (e) { self.up(e); });
    cv.addEventListener('pointercancel', function (e) { self.up(e); });
    cv.addEventListener('dblclick', function () { self.reset(); });
  };
  Viewer.prototype.resize = function () {
    var v = this.v; if (!v) return;
    var w = this.cv.clientWidth, h = this.cv.clientHeight; if (!w || !h) return;
    v.r.setSize(w, h, false); v.cam.aspect = w / h; v.cam.updateProjectionMatrix(); this.frame();
  };
  Viewer.prototype.active = function () {
    var v = this.v; if (!v) return [];
    return v.fmt === 'double' ? [v.rigs[0], v.rigs[2]] : (v.fmt === 'prise' ? [] : [v.rigs[1]]);
  };
  Viewer.prototype.set = function (o) { this.want = o; this.sync(); };
  Viewer.prototype.sync = function () {
    var v = this.v, o = this.want, self = this; if (!v || !o) return;
    var T = v.T, fmt = o.format || 'simple', suf = fmt === 'double' ? '_d' : (fmt === 'prise' ? '_p' : '');
    v.fmt = fmt;
    Object.keys(v.covers).forEach(function (k) { v.covers[k].visible = !o.avant && k === o.finish + suf; });
    var act = this.active();
    v.rigs.forEach(function (rg) {
      var on = act.indexOf(rg) >= 0;
      rg.pivot.visible = on && !o.avant;
      Object.keys(rg.embs).forEach(function (k) { rg.embs[k].visible = k === o.embout; });
      rg.rock.pivot.visible = on && !!o.avant;
    });
    v.before.visible = !!o.avant || fmt === 'prise';
    v.socket.visible = fmt === 'prise';
    v.coverMat.color.set(o.cover); v.leverMat.color.set(o.key);
    var sx = (o.w + 6) / 86, sy = (o.h + 6) / 86;
    Object.keys(v.covers).forEach(function (k) { v.covers[k].scale.set(sx, sy, 1); });
    var dk = o.w + 'x' + o.h;
    if (v.dims !== dk) {
      v.dims = dk;
      if (v.plate.geometry) v.plate.geometry.dispose();
      v.plate.geometry = roundRect(T, o.w, o.h, 4, 9, 1.2, true);
      v.plate.position.z = -20 + 9;
      var kw = Math.min(o.w, 87);
      v.rigs.forEach(function (rg) {
        if (rg.rock.mesh.geometry) rg.rock.mesh.geometry.dispose();
        rg.rock.mesh.geometry = rg.x === 0 ? roundRect(T, kw * 0.46, o.h * 0.58, 3, 3, 0.9, true) : roundRect(T, kw * 0.225, o.h * 0.58, 2.5, 3, 0.9, true);
        rg.rock.pivot.position.x = rg.x === 0 ? 0 : (rg.x < 0 ? 1 : -1) * (kw * 0.1175 + 0.4);
      });
      v.span = Math.max(o.w, o.h) + 6;
    }
    this._night();
    this.frame();
  };
  Viewer.prototype._night = function () {
    var night = this.active().some(function (rg) { return rg.tilt > 0; });
    if (night !== this.lastNight) { this.lastNight = night; if (this.onNight) this.onNight(night); }
  };
  Viewer.prototype.frame = function () {
    var v = this.v, self = this; if (!v || v.raf) return;
    v.raf = requestAnimationFrame(function () { v.raf = 0; self.draw(); });
  };
  Viewer.prototype.draw = function () {
    var v = this.v; if (!v) return;
    var moving = false;
    v.rigs.forEach(function (rg) {
      var d = rg.tilt - rg.tiltNow; rg.tiltNow += d * 0.28;
      if (Math.abs(d) < 0.001) rg.tiltNow = rg.tilt; else moving = true;
      rg.pivot.rotation.x = rg.tiltNow;
      rg.rock.pivot.rotation.x = -rg.tiltNow * 0.6;
    });
    var nT = this.active().some(function (rg) { return rg.tilt > 0; }) ? 1 : 0, dn = nT - v.nNow;
    v.nNow += dn * 0.14;
    if (Math.abs(dn) < 0.002) v.nNow = nT; else moving = true;
    var n = v.nNow, L = function (a, b) { return a + (b - a) * n; };
    v.hemi.intensity = L(0.48, 0.17); v.key.intensity = L(0.82, 0.34); v.fill.intensity = L(0.22, 0.04);
    v.hemi.color.copy(v.cDay.sky).lerp(v.cNight.sky, n); v.hemi.groundColor.copy(v.cDay.gnd).lerp(v.cNight.gnd, n);
    v.key.color.copy(v.cDay.key).lerp(v.cNight.key, n);
    var span = v.span || 92;
    var fit = (span * 0.5) / Math.tan((v.cam.fov * Math.PI) / 360);
    var dist = fit * 1.9 / Math.min(1, v.cam.aspect * 0.95);
    var cp = Math.cos(v.pitch);
    v.cam.position.set(Math.sin(v.yaw) * cp * dist, Math.sin(v.pitch) * dist, -8 + Math.cos(v.yaw) * cp * dist);
    v.cam.lookAt(0, 0, -8);
    v.r.render(v.scene, v.cam);
    if (moving) this.frame();
  };
  Viewer.prototype.down = function (e) {
    var v = this.v; if (!v) return;
    v.drag = { x: e.clientX, y: e.clientY, yaw: v.yaw, pitch: v.pitch, moved: 0 };
    try { this.cv.setPointerCapture(e.pointerId); } catch (err) {}
  };
  Viewer.prototype.move = function (e) {
    var v = this.v; if (!v || !v.drag) return;
    var dx = e.clientX - v.drag.x, dy = e.clientY - v.drag.y;
    v.drag.moved = Math.max(v.drag.moved, Math.abs(dx) + Math.abs(dy));
    v.yaw = Math.max(-1.1, Math.min(1.1, v.drag.yaw - dx * 0.008));
    v.pitch = Math.max(-0.75, Math.min(0.85, v.drag.pitch + dy * 0.006));
    this.frame();
  };
  Viewer.prototype.up = function (e) {
    var v = this.v; if (!v || !v.drag) return;
    var click = v.drag.moved < 5; v.drag = null;
    if (!click || e.type === 'pointercancel') return;
    var rect = this.cv.getBoundingClientRect();
    var p = new v.T.Vector2(((e.clientX - rect.left) / rect.width) * 2 - 1, -((e.clientY - rect.top) / rect.height) * 2 + 1);
    v.ray.setFromCamera(p, v.cam);
    var shown = function (o) { while (o) { if (!o.visible) return false; o = o.parent; } return true; };
    var targets = [];
    v.rigs.forEach(function (rg) { targets.push(rg.lever, rg.rock.mesh); Object.keys(rg.embs).forEach(function (k) { targets.push(rg.embs[k]); }); });
    var hit = v.ray.intersectObjects(targets, false).filter(function (h) { return shown(h.object); })[0];
    if (!hit) return;
    var rg = v.rigs.find(function (x) { return x.rock.mesh === hit.object || x.lever === hit.object || Object.keys(x.embs).some(function (k) { return x.embs[k] === hit.object; }); });
    if (rg) this.toggle(rg);
  };
  Viewer.prototype.toggle = function (one) {
    var v = this.v; if (!v) return;
    var act = this.active(); if (!act.length) return;
    if (one) one.tilt = -one.tilt;
    else { var up = act.some(function (rg) { return rg.tilt > 0; }); act.forEach(function (rg) { rg.tilt = up ? -0.16 : 0.16; }); }
    this.frame(); this._night();
  };
  Viewer.prototype.isNight = function () { return this.active().some(function (rg) { return rg.tilt > 0; }); };
  Viewer.prototype.reset = function () { var v = this.v; if (!v) return; v.yaw = -0.42; v.pitch = 0.26; this.frame(); };
  B.Viewer = Viewer;

  /* ---------- Guide de mesure animé ---------- */
  var DIMS = {
    dooxie: { w: 87, h: 87, t: 10, name: 'Legrand Dooxie' },
    celiane: { w: 90, h: 82, t: 9, name: 'Legrand Céliane' },
    odace: { w: 87.5, h: 87.5, t: 12, name: 'Schneider Odace' },
    autre: { w: 85, h: 85, t: 10, name: 'Sur mesure' }
  };
  function num(v) { return (Math.round(v * 100) / 100).toString().replace('.', ','); }
  function Guide(canvas, models, o) {
    this.cv = canvas; this.models = models; this.mode = o.mode || 'simple'; this.brand = o.brand || 'dooxie';
    this.playing = o.playing !== false; this.reduced = !!o.reduced; this.onStep = o.onStep || function () {};
    this.g = null;
  }
  Guide.prototype.dims = function () {
    if (this.mode === 'double') { var e = this.brand === 'e57' ? 57 : 71; return { w: 87 + e, h: 87, t: 10, e: e, name: 'Cache double', double: true }; }
    return DIMS[this.brand] || DIMS.dooxie;
  };
  Guide.prototype.phases = function () { return this.mode === 'double' ? ['w', 'h', 'e', 't', 'c'] : ['w', 'h', 't', 'c']; };
  Guide.prototype.label = function (text, o) {
    var T = window.THREE; o = o || {};
    var px = 96, pad = 40, c = document.createElement('canvas'), x = c.getContext('2d');
    var font = '700 ' + px + 'px "DM Sans", "Helvetica Neue", Arial, sans-serif';
    x.font = font;
    var w = Math.ceil(x.measureText(text).width) + pad * 2, h = px + pad * 1.3;
    c.width = w; c.height = h;
    x.font = font; x.fillStyle = o.bg || '#1A1E50';
    var r = h / 2;
    x.beginPath(); x.moveTo(r, 0); x.lineTo(w - r, 0); x.arc(w - r, r, r, -Math.PI / 2, Math.PI / 2); x.lineTo(r, h); x.arc(r, r, r, Math.PI / 2, Math.PI * 1.5); x.fill();
    x.fillStyle = o.fg || '#FBFAF3'; x.textBaseline = 'middle'; x.textAlign = 'center'; x.fillText(text, w / 2, h / 2 + 4);
    var tex = new T.CanvasTexture(c); tex.encoding = T.sRGBEncoding; tex.anisotropy = 4;
    var sp = new T.Sprite(new T.SpriteMaterial({ map: tex, transparent: true, depthTest: false, opacity: 0 }));
    var hh = o.size || 7;
    sp.scale.set(hh * w / h, hh, 1); sp.renderOrder = 10;
    return sp;
  };
  Guide.prototype.rulerTex = function (T, L) {
    var c = document.createElement('canvas'); c.width = Math.round(L * 20.48); c.height = 410;
    var x = c.getContext('2d'), k = c.width / L;
    x.fillStyle = '#F0BF3C'; x.fillRect(0, 0, c.width, c.height);
    x.fillStyle = '#1A1E50';
    for (var mm = 0; mm <= L; mm++) {
      var len = mm % 10 === 0 ? 8 : (mm % 5 === 0 ? 5.5 : 3.2);
      x.fillRect(Math.round(mm * k) - 2, c.height - len * k, 4, len * k);
    }
    x.font = '700 ' + Math.round(4.6 * k) + 'px "DM Sans", Arial, sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle';
    for (var cm = 0; cm <= L / 10; cm++) x.fillText(String(cm), Math.min(c.width - 3 * k, Math.max(3 * k, cm * 10 * k)), 5.2 * k);
    var tex = new T.CanvasTexture(c); tex.encoding = T.sRGBEncoding; tex.anisotropy = 8;
    return tex;
  };
  Guide.prototype.init = function () {
    var T = window.THREE, cv = this.cv, self = this;
    try { T.ColorManagement.legacyMode = false; } catch (e) {}
    var r = new T.WebGLRenderer({ canvas: cv, antialias: true, alpha: true });
    r.outputEncoding = T.sRGBEncoding; r.shadowMap.enabled = true; r.shadowMap.type = T.PCFSoftShadowMap;
    r.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    var scene = new T.Scene(), cam = new T.PerspectiveCamera(28, 1, 10, 4000);
    scene.add(new T.HemisphereLight(0xfffaf0, 0xcfc6b4, 0.5));
    var key = new T.DirectionalLight(0xffffff, 0.8);
    key.position.set(-110, 150, 150); key.castShadow = true; key.shadow.mapSize.set(2048, 2048);
    Object.assign(key.shadow.camera, { left: -200, right: 200, top: 200, bottom: -200, near: 20, far: 700 });
    key.shadow.bias = -0.0004; key.shadow.normalBias = 0.15; key.shadow.radius = 3;
    scene.add(key);
    var fill = new T.DirectionalLight(0xfff4e2, 0.25); fill.position.set(150, -40, 120); scene.add(fill);
    var wall = new T.Mesh(new T.PlaneGeometry(1600, 1600), new T.ShadowMaterial({ color: 0x2a2440, opacity: 0.18 }));
    wall.receiveShadow = true; scene.add(wall);
    var mk = function (L) {
      var yellow = new T.MeshStandardMaterial({ color: 0xF0BF3C, roughness: 0.55, transparent: true });
      var face = new T.MeshStandardMaterial({ map: self.rulerTex(T, L), roughness: 0.55, transparent: true });
      var rg = new T.BoxGeometry(L, 20, 1.2); rg.translate(L / 2, 10, 0.6);
      var m = new T.Mesh(rg, [yellow, yellow, yellow, yellow, face, yellow]); m.castShadow = true; scene.add(m);
      return { mesh: m, mats: [yellow, face] };
    };
    var ruler = mk(300), ruler2 = mk(80);
    ruler2.mesh.setRotationFromMatrix(new T.Matrix4().makeBasis(new T.Vector3(0, 0, 1), new T.Vector3(1, 0, 0), new T.Vector3(0, 1, 0)));
    var coverMat = new T.MeshStandardMaterial({ color: 0xC2623F, roughness: 0.82, transparent: true });
    this.g = { T: T, r: r, scene: scene, cam: cam, ruler: ruler, ruler2: ruler2, coverMat: coverMat, dyn: null, t: 0, last: 0, raf: 0, step: -1, visible: true };
    if (window.ResizeObserver) { this.ro = new ResizeObserver(function () { self.resize(); }); this.ro.observe(cv); }
    if (window.IntersectionObserver) { this.io = new IntersectionObserver(function (es) { if (self.g) { self.g.visible = es[0].isIntersecting; if (self.g.visible) self.loop(); } }); this.io.observe(cv); }
    this.build();
    this.resize();
    if (this.reduced || !this.playing) this.seek(0); else this.loop();
  };
  Guide.prototype.build = function () {
    var g = this.g; if (!g) return;
    var T = g.T, d = this.dims(), self = this;
    if (g.dyn) { g.dyn.traverse(function (o) { if (o.geometry) o.geometry.dispose(); if (o.material && o.material !== g.coverMat) { if (o.material.map) o.material.map.dispose(); o.material.dispose(); } }); g.scene.remove(g.dyn); }
    var dyn = new T.Group(); g.scene.add(dyn); g.dyn = dyn;
    var W = d.w, H = d.h, Th = d.t, E = d.e || 0;
    var xs = d.double ? [-E / 2, E / 2] : [0];
    var kw = Math.min(d.double ? 87 : W, 87) * 0.46, kh = H * 0.58;
    var plate = new T.Mesh(roundRect(T, W, H, 4, Th, 1.2), new T.MeshStandardMaterial({ color: 0xf7f6f1, roughness: 0.4 }));
    plate.castShadow = true; plate.receiveShadow = true; dyn.add(plate);
    xs.forEach(function (x) {
      var rock = new T.Mesh(roundRect(T, kw, kh, 3, 3, 0.9), new T.MeshStandardMaterial({ color: 0xfcfcf9, roughness: 0.35 }));
      rock.position.set(x, 0, Th); rock.castShadow = true; rock.receiveShadow = true; dyn.add(rock);
    });
    var navy = 0x1A1E50, mand = 0xF58334;
    var lineMat = function () { return new T.MeshBasicMaterial({ color: navy, transparent: true, opacity: 0, depthTest: false }); };
    var dimLine = function (len, axis) {
      var grp = new T.Group(), m = lineMat();
      var bar = new T.Mesh(new T.BoxGeometry(axis === 'x' ? len : 0.7, axis === 'y' ? len : 0.7, 0.7), m);
      grp.add(bar);
      [-1, 1].forEach(function (s) {
        var tick = new T.Mesh(new T.BoxGeometry(axis === 'x' ? 0.7 : 6, axis === 'x' ? 6 : 0.7, 0.7), m);
        tick.position[axis] = s * len / 2; grp.add(tick);
      });
      grp.userData.mat = m; bar.renderOrder = 9;
      return grp;
    };
    var mark = function () { var m = new T.Mesh(new T.BoxGeometry(0.9, 26, 0.5), new T.MeshBasicMaterial({ color: mand, transparent: true, opacity: 0, depthTest: false })); m.renderOrder = 9; return m; };
    var lab = function (t, o) { return self.label(t, o); };
    var A = {};
    A.wLine = dimLine(W, 'x'); A.wLine.position.set(0, -H / 2 - 11, Th); dyn.add(A.wLine);
    A.wLab = lab((d.double ? 'Largeur totale ' : 'Largeur ') + num(W) + ' mm'); A.wLab.position.set(0, -H / 2 - 21, Th); dyn.add(A.wLab);
    A.wM1 = mark(); A.wM1.position.set(-W / 2, H / 2 - 8, Th + 1.4); dyn.add(A.wM1);
    A.wM2 = mark(); A.wM2.position.set(W / 2, H / 2 - 8, Th + 1.4); dyn.add(A.wM2);
    A.wR1 = lab('10', { bg: '#F58334', size: 5.5 }); A.wR1.position.set(-W / 2, H / 2 + 11, Th + 2); dyn.add(A.wR1);
    A.wR2 = lab(num((100 + W) / 10), { bg: '#F58334', size: 5.5 }); A.wR2.position.set(W / 2, H / 2 + 11, Th + 2); dyn.add(A.wR2);
    A.hLine = dimLine(H, 'y'); A.hLine.position.set(W / 2 + 11, 0, Th); dyn.add(A.hLine);
    A.hLab = lab('Hauteur ' + num(H) + ' mm'); A.hLab.position.set(W / 2 + 11, H / 2 + 12, Th); dyn.add(A.hLab);
    A.hM1 = mark(); A.hM1.rotation.z = Math.PI / 2; A.hM1.position.set(-W / 2 + 8, -H / 2, Th + 1.4); dyn.add(A.hM1);
    A.hM2 = mark(); A.hM2.rotation.z = Math.PI / 2; A.hM2.position.set(-W / 2 + 8, H / 2, Th + 1.4); dyn.add(A.hM2);
    A.hR1 = lab('10', { bg: '#F58334', size: 5.5 }); A.hR1.position.set(-W / 2 - 12, -H / 2, Th + 2); dyn.add(A.hR1);
    A.hR2 = lab(num((100 + H) / 10), { bg: '#F58334', size: 5.5 }); A.hR2.position.set(-W / 2 - 14, H / 2, Th + 2); dyn.add(A.hR2);
    if (d.double) {
      var zE = Th + 3.2, l1 = -E / 2 - kw / 2, l2 = E / 2 - kw / 2;
      A.eM1 = mark(); A.eM1.position.set(l1, 0, zE + 1.4); dyn.add(A.eM1);
      A.eM2 = mark(); A.eM2.position.set(l2, 0, zE + 1.4); dyn.add(A.eM2);
      A.eR1 = lab('10', { bg: '#F58334', size: 5.5 }); A.eR1.position.set(l1, 19, zE + 2); dyn.add(A.eR1);
      A.eR2 = lab(num((100 + E) / 10), { bg: '#F58334', size: 5.5 }); A.eR2.position.set(l2, 19, zE + 2); dyn.add(A.eR2);
      A.eLine = dimLine(E, 'x'); A.eLine.position.set(0, -kh / 2 - 9, zE); dyn.add(A.eLine);
      A.eLab = lab('Entraxe ' + num(E) + ' mm'); A.eLab.position.set(0, -kh / 2 - 19, zE); dyn.add(A.eLab);
      A.eC = [];
      xs.forEach(function (x) {
        var dot = new T.Mesh(new T.CircleGeometry(1.8, 24), new T.MeshBasicMaterial({ color: navy, transparent: true, opacity: 0, depthTest: false }));
        dot.position.set(x, 0, zE + 0.3); dot.renderOrder = 9; dyn.add(dot); A.eC.push(dot);
        var vv = new T.Mesh(new T.BoxGeometry(0.5, kh / 2 + 9, 0.5), new T.MeshBasicMaterial({ color: navy, transparent: true, opacity: 0, depthTest: false }));
        vv.position.set(x, -(kh / 2 + 9) / 2, zE + 0.3); vv.renderOrder = 9; dyn.add(vv); A.eC.push(vv);
      });
    }
    A.tLab = lab('Épaisseur ' + num(Th) + ' mm'); A.tLab.position.set(-24, H / 2 + 12, Th); dyn.add(A.tLab);
    A.tM = new T.Mesh(new T.BoxGeometry(26, 0.5, 0.9), new T.MeshBasicMaterial({ color: mand, transparent: true, opacity: 0, depthTest: false })); A.tM.renderOrder = 9; A.tM.position.set(0, H / 2 + 1.5, Th); dyn.add(A.tM);
    var cTxt = d.double ? 'Cache double · ' + num(W) + ' × ' + num(H) + ' mm · entraxe ' + num(E) : d.name + ' · cache ' + num(W) + ' × ' + num(H) + ' mm';
    A.cLab = lab(cTxt, { bg: '#1A1E50', size: 7 }); A.cLab.position.set(0, -H / 2 - 16, 26); dyn.add(A.cLab);
    var cover = new T.Group(); cover.rotation.y = Math.PI; dyn.add(cover);
    if (d.double) {
      var outer = shape(T, W + 6, H + 6, 5);
      xs.forEach(function (x) { var hole = new T.Path(); hole.moveTo(x - 4, -8); hole.lineTo(x + 4, -8); hole.lineTo(x + 4, 8); hole.lineTo(x - 4, 8); hole.lineTo(x - 4, -8); outer.holes.push(hole); });
      var faceG = new T.ExtrudeGeometry(outer, { depth: 3, bevelEnabled: false, curveSegments: 6 });
      var ring = shape(T, W + 6, H + 6, 5); ring.holes.push(shape(T, W, H, 3));
      var wallG = new T.ExtrudeGeometry(ring, { depth: 17, bevelEnabled: false, curveSegments: 6 }); wallG.translate(0, 0, 3);
      [faceG, wallG].forEach(function (gg) { var m = new T.Mesh(gg, g.coverMat); m.castShadow = true; m.receiveShadow = true; cover.add(m); });
    } else {
      var m = new T.Mesh(decode(T, this.models.lisse), g.coverMat); m.castShadow = true; m.receiveShadow = true; m.scale.set((W + 6) / 86, (H + 6) / 86, 1); cover.add(m);
    }
    var levG = decode(T, this.models.levier);
    xs.forEach(function (x) {
      var lp = new T.Group(); lp.position.set(-x, 0, 6.25); lp.rotation.x = -0.16; cover.add(lp);
      var lever = new T.Mesh(levG, g.coverMat); lever.rotation.x = Math.PI; lever.position.z = 1.25; lever.castShadow = true; lp.add(lever);
    });
    g.cover = cover; g.A = A; g.d = d; g.ph = this.phases(); g.total = g.ph.length * 5; g.t = 0; g.step = -1;
  };
  Guide.prototype.resize = function () {
    var g = this.g; if (!g) return;
    var w = this.cv.clientWidth, h = this.cv.clientHeight; if (!w || !h) return;
    g.r.setSize(w, h, false); g.cam.aspect = w / h; g.cam.updateProjectionMatrix(); this.draw();
  };
  Guide.prototype.loop = function () {
    var g = this.g, self = this; if (!g || g.raf) return;
    var tick = function (now) {
      g.raf = 0; if (!self.g) return;
      var dt = g.last ? Math.min(0.1, (now - g.last) / 1000) : 0; g.last = now;
      if (self.playing && !self.reduced) g.t = (g.t + dt) % g.total;
      self.draw();
      if (self.playing && g.visible && !self.reduced) g.raf = requestAnimationFrame(tick); else g.last = 0;
    };
    g.raf = requestAnimationFrame(tick);
  };
  Guide.prototype.draw = function () {
    var g = this.g; if (!g) return;
    var d = g.d, A = g.A, W = d.w, H = d.h, Th = d.t, E = d.e || 0;
    var ss = function (a, b, x) { var u = Math.min(1, Math.max(0, (x - a) / (b - a))); return u * u * (3 - 2 * u); };
    var pi = Math.min(g.ph.length - 1, Math.floor(g.t / 5)), ph = g.ph[pi], u = g.t - pi * 5;
    var fade = function (a, b, c, e) { return ss(a, b, u) * (1 - ss(c, e, u)); };
    var op = function (o, val) { if (!o) return; if (o.material) { o.material.opacity = val; o.visible = val > 0.01; } else if (o.userData.mat) { o.userData.mat.opacity = val; o.visible = val > 0.01; } };
    if (pi !== g.step) { g.step = pi; this.onStep(pi); }
    ['wM1', 'wM2', 'wR1', 'wR2', 'wLine', 'wLab', 'hM1', 'hM2', 'hR1', 'hR2', 'hLine', 'hLab', 'eM1', 'eM2', 'eR1', 'eR2', 'eLine', 'eLab', 'tM', 'tLab', 'cLab'].forEach(function (k) { op(A[k], 0); });
    (A.eC || []).forEach(function (o) { op(o, 0); });
    var R = g.ruler.mesh, R2 = g.ruler2.mesh, ro = 0, r2o = 0;
    R.rotation.set(0, 0, 0);
    var slide = (1 - ss(0.2, 1.4, u)) * 70;
    if (ph === 'w') {
      ro = fade(0.2, 1.1, 4.4, 4.9); R.position.set(-W / 2 - 100 - slide, H / 2 - 18, Th);
      op(A.wM1, fade(1.6, 2.0, 4.4, 4.9)); op(A.wM2, fade(1.8, 2.2, 4.4, 4.9)); op(A.wR1, fade(1.7, 2.1, 4.4, 4.9)); op(A.wR2, fade(2.0, 2.4, 4.4, 4.9));
      op(A.wLine, fade(2.6, 3.1, 4.5, 5.0)); op(A.wLab, fade(2.8, 3.3, 4.5, 5.0));
    } else if (ph === 'h') {
      ro = fade(0.2, 1.1, 4.4, 4.9); R.rotation.z = Math.PI / 2; R.position.set(-W / 2 + 18, -H / 2 - 100 - slide, Th);
      op(A.hM1, fade(1.6, 2.0, 4.4, 4.9)); op(A.hM2, fade(1.8, 2.2, 4.4, 4.9)); op(A.hR1, fade(1.7, 2.1, 4.4, 4.9)); op(A.hR2, fade(2.0, 2.4, 4.4, 4.9));
      op(A.hLine, fade(2.6, 3.1, 4.5, 5.0)); op(A.hLab, fade(2.8, 3.3, 4.5, 5.0));
    } else if (ph === 'e') {
      var kw = 87 * 0.46;
      ro = fade(0.2, 1.1, 4.4, 4.9); R.position.set(-E / 2 - kw / 2 - 100 - slide, -10, Th + 3.3);
      op(A.eM1, fade(1.6, 2.0, 4.4, 4.9)); op(A.eM2, fade(1.8, 2.2, 4.4, 4.9)); op(A.eR1, fade(1.7, 2.1, 4.4, 4.9)); op(A.eR2, fade(2.0, 2.4, 4.4, 4.9));
      (A.eC || []).forEach(function (o) { op(o, fade(2.5, 3.0, 4.5, 5.0)); });
      op(A.eLine, fade(2.6, 3.1, 4.5, 5.0)); op(A.eLab, fade(2.8, 3.3, 4.5, 5.0));
    } else if (ph === 't') {
      r2o = fade(1.0, 1.8, 4.4, 4.9);
      R2.position.set(-10, H / 2 + 0.05, (1 - ss(1.0, 2.2, u)) * 40);
      op(A.tM, fade(2.4, 2.8, 4.4, 4.9)); op(A.tLab, fade(2.8, 3.3, 4.5, 5.0));
    }
    g.ruler.mats.forEach(function (m) { m.opacity = ro; }); R.visible = ro > 0.01;
    g.ruler2.mats.forEach(function (m) { m.opacity = r2o; }); R2.visible = r2o > 0.01;
    var co = ph === 'c' ? fade(0.5, 1.1, 4.5, 4.95) : 0;
    g.cover.visible = co > 0.01; g.coverMat.opacity = co; g.coverMat.transparent = co < 0.999; g.coverMat.depthWrite = co > 0.5;
    g.cover.position.z = 20 + (1 - ss(0.5, 2.0, u)) * 45;
    if (ph === 'c') op(A.cLab, fade(2.2, 2.7, 4.4, 4.9));
    var CAM = { w: [-0.22, 0.1, 1.0], h: [-0.22, 0.1, 1.0], e: [-0.2, 0.14, 0.9], t: [-0.62, 0.62, 0.82], c: [-0.48, 0.24, 1.0] };
    var prev = CAM[g.ph[(pi + g.ph.length - 1) % g.ph.length]], cur = CAM[ph];
    var k = prev.map(function (val, i) { return val + (cur[i] - val) * ss(0, 1.0, u); });
    var span = Math.max(W, H) + 56;
    var dist = (span * 0.5) / Math.tan((g.cam.fov * Math.PI) / 360) * 1.25 * k[2] / Math.min(1, g.cam.aspect * 0.95);
    var cp = Math.cos(k[1]), tz = Th / 2;
    g.cam.position.set(Math.sin(k[0]) * cp * dist, Math.sin(k[1]) * dist, tz + Math.cos(k[0]) * cp * dist);
    g.cam.lookAt(0, 0, tz);
    g.r.render(g.scene, g.cam);
  };
  Guide.prototype.seek = function (i) {
    var g = this.g; if (!g) return;
    g.t = i * 5 + ((!this.playing || this.reduced) ? 4.2 : 0.05);
    this.draw();
  };
  Guide.prototype.setBrand = function (mode, brand) {
    this.mode = mode; this.brand = brand;
    if (!this.g) return;
    this.build();
    if (!this.playing || this.reduced) this.seek(0); else this.draw();
  };
  Guide.prototype.setPlaying = function (p) {
    this.playing = p;
    if (p) { this.reduced = false; this.loop(); }
  };
  Guide.prototype.dispose = function () {
    var g = this.g; if (!g) return;
    if (g.raf) cancelAnimationFrame(g.raf);
    if (this.ro) { this.ro.disconnect(); this.ro = null; }
    if (this.io) { this.io.disconnect(); this.io = null; }
    g.scene.traverse(function (o) { if (o.geometry) o.geometry.dispose(); var ms = Array.isArray(o.material) ? o.material : (o.material ? [o.material] : []); ms.forEach(function (m) { if (m.map) m.map.dispose(); m.dispose(); }); });
    g.r.dispose();
    this.g = null;
  };
  B.Guide = Guide;
})();
